var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2377_236)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2377_236",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.5H0V24.5H24V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2377_236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5C9.62663 0.5 7.30655 1.20379 5.33316 2.52236C3.35977 3.84094 1.8217 5.71508 0.913451 7.9078C0.00519973 10.1005 -0.232441 12.5133 0.230582 14.8411C0.693605 17.1689 1.83649 19.307 3.51472 20.9853C5.19295 22.6635 7.33115 23.8064 9.65892 24.2694C11.9867 24.7324 14.3995 24.4948 16.5922 23.5865C18.7849 22.6783 20.6591 21.1402 21.9776 19.1668C23.2962 17.1934 24 14.8734 24 12.5C23.9966 9.31843 22.7313 6.26814 20.4816 4.01843C18.2319 1.76872 15.1816 0.50336 12 0.5ZM12 22.6538C9.99176 22.6538 8.02862 22.0583 6.35883 20.9426C4.68904 19.8269 3.38759 18.2411 2.61907 16.3857C1.85055 14.5303 1.64947 12.4887 2.04126 10.5191C2.43305 8.54943 3.40011 6.74019 4.82015 5.32015C6.24019 3.90011 8.04943 2.93304 10.0191 2.54126C11.9887 2.14947 14.0303 2.35055 15.8857 3.11907C17.7411 3.88759 19.3269 5.18903 20.4426 6.85882C21.5583 8.52861 22.1538 10.4918 22.1538 12.5C22.1508 15.192 21.08 17.7729 19.1765 19.6765C17.2729 21.58 14.692 22.6508 12 22.6538ZM12 4.19231C10.3569 4.19231 8.75069 4.67954 7.3845 5.59241C6.0183 6.50527 4.95349 7.80275 4.3247 9.32078C3.69591 10.8388 3.53139 12.5092 3.85194 14.1207C4.1725 15.7323 4.96373 17.2126 6.12558 18.3744C7.28743 19.5363 8.76772 20.3275 10.3793 20.6481C11.9908 20.9686 13.6612 20.8041 15.1792 20.1753C16.6973 19.5465 17.9947 18.4817 18.9076 17.1155C19.8205 15.7493 20.3077 14.1431 20.3077 12.5C20.3053 10.2974 19.4292 8.18574 17.8717 6.62827C16.3143 5.07081 14.2026 4.19475 12 4.19231ZM12 18.9615C10.722 18.9615 9.47276 18.5826 8.41017 17.8726C7.34757 17.1626 6.51938 16.1534 6.03032 14.9727C5.54126 13.792 5.4133 12.4928 5.66262 11.2394C5.91194 9.986 6.52734 8.83466 7.43101 7.931C8.33467 7.02734 9.486 6.41194 10.7394 6.16262C11.9928 5.9133 13.292 6.04126 14.4727 6.53032C15.6534 7.01937 16.6626 7.84757 17.3726 8.91016C18.0826 9.97275 18.4615 11.222 18.4615 12.5C18.4597 14.2131 17.7784 15.8556 16.567 17.067C15.3556 18.2783 13.7131 18.9597 12 18.9615Z",
    fill: "#2B2B67"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2377_236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedIcon);
export default __webpack_public_path__ + "static/media/rounded-icon.bde79515a52317ebcef66027f19f9e75.svg";
export { ForwardRef as ReactComponent };